<template>
  <div
    class="button-group"
    :class="{ white, }"
  >
    <slot name="default" />
  </div>
</template>

<script>
import { defineComponent } from "vue";
/**
 * Affiche une liste de boutons dont un seul peut être actif.
 */
export default defineComponent({
  name: "ButtonGroup",
  props: {
    /**
     * Identifiant HTML de l'élement sélectionné.
     */
    selectedId: {
      type: String,
      default: null,
    },
    /**
     * Change le fond en blanc.
     */
    white: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    selectedId(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.removeSelect(oldValue);
        this.addSelect(newValue);
      }
    },
  },
  mounted() {
    if (this.selectedId) {
      this.addSelect(this.selectedId);
    }
  },
  methods: {
    /**
     * Ajoute la classe "select" un élément.
     * @param {String} id Identifiant HTML de l'élément.
     */
    addSelect(id) {
      const element = this.$children.find((child) => child.$el.id === id);
      if (element) {
        element.$el.classList.add("select");
      }
    },
    /**
     * Retire la classe "select" à un élément.
     * @param {String} id Identifiant HTML de l'élément.
     */
    removeSelect(id) {
      const element = this.$children.find((child) => child.$el.id === id);
      if (element) {
        element.$el.classList.remove("select");
      }
    },
  },
});
</script>

<style lang="scss">
@use "../../assets/styles/components/buttons/button_group.scss";
</style>
